
const indexedDB = window.indexedDB || (window as any).webkitIndexedDB || (window as any).mozIndexedDB || (window as any).OIndexedDB || (window as any).msIndexedDB;
IDBTransaction = window.IDBTransaction || (window as any).webkitIDBTransaction || (window as any).OIDBTransaction || (window as any).msIDBTransaction;

export default class IndexDBService {

  #db: IDBDatabase;
  get db() {
    return this.#db;
  }
  
  #storeName = 'localFiles';
  #storeKey = 'name';
  #dbVersion = 1;
  #dbName: string;

  constructor(dbName: string) {
    this.#dbName = dbName;
  }

  async init() {
    this.#db = await this.#initIndexedDb(this.#dbName, [{ name: this.#storeName, keyPath: this.#storeKey }]);
    return;
  }

  #initIndexedDb(dbName: string, stores: {name: string, keyPath: string}[] ): Promise<IDBDatabase>  {
    return new Promise((resolve, reject) => {
      const request: IDBOpenDBRequest = indexedDB.open(dbName, this.#dbVersion);
      request.onerror = (e) => {
        reject((e.target as IDBRequest).error);
      };
      request.onsuccess = (e) => {
        resolve((e.target as IDBRequest).result);
      };
      request.onupgradeneeded = (e) => {
        stores.forEach((store) => {
          const objectStore = (e.target as IDBRequest).result.createObjectStore(store.name, {
            keyPath: store.keyPath,
          });
          objectStore.createIndex(store.keyPath, store.keyPath, { unique: true });
        });
      };
    });
  }

  addFile(file: File, overwrite = true): Promise<IDBRequest> {
    const store = this.#db.transaction(this.#storeName, 'readwrite').objectStore(this.#storeName);
	  const keyRequest = store.getKey(file.name);
    let request: IDBRequest<IDBValidKey>;
    return new Promise ((resolve, reject) => {
      keyRequest.onsuccess = () => {
        if (!keyRequest.result) {
          request = store.add(file);
        } else if (overwrite) {
          request = store.put(file);
        }
        if (request) {
          request.onsuccess = (e) => {
            resolve((e.target as IDBRequest).result);
          }
          request.onerror = (e) => {
            reject((e.target as IDBRequest).error);
          }
        } else {
          reject(`Key, ${file.name}, already exists in DB.`);
        }
      }
      keyRequest.onerror = (e) => {
        reject((e.target as IDBRequest).error);
      }
    });
  }

  getKey(key: string): Promise<IDBRequest> {
    const store = this.#db.transaction(this.#storeName, 'readonly').objectStore(this.#storeName);
    const request = store.getKey(key)
    return new Promise ((resolve, reject) => {
      request.onsuccess = (e) => {
        resolve((e.target as IDBRequest).result);
      }
      request.onerror = (e) => {
        reject((e.target as IDBRequest).error);
      }
    });
  }

  getFile(key: string): Promise<File | DOMException | null> {
    const store = this.#db.transaction(this.#storeName, 'readonly').objectStore(this.#storeName);
    const request = store.get(key)
    return new Promise ((resolve, reject) => {
      request.onsuccess = (e) => {
        resolve((e.target as IDBRequest).result);
      }
      request.onerror = (e) => {
        reject((e.target as IDBRequest).error);
      }
    });
  }

  deleteFile(key: string): Promise<IDBRequest> {
    const store = this.#db.transaction(this.#storeName, 'readwrite').objectStore(this.#storeName);
	  const request = store.delete(key);
    return new Promise ((resolve, reject) => {
      request.onsuccess = (e) => {
        resolve((e.target as IDBRequest).result);
      }
      request.onerror = (e) => {
        reject((e.target as IDBRequest).error);
      }
    });
  }

  clear(): Promise<IDBRequest> {
    const store = this.#db.transaction(this.#storeName, 'readwrite').objectStore(this.#storeName);
	  const request = store.clear();
    return new Promise ((resolve, reject) => {
      request.onsuccess = (e) => {
        resolve((e.target as IDBRequest).result);
      }
      request.onerror = (e) => {
        reject((e.target as IDBRequest).error);
      }
    });
  }

}